import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RobotIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 2C9 2.37014 8.7989 2.69331 8.5 2.86622V3.5C8.5 3.77614 8.72386 4 9 4H9.5C10.8978 4 11.5967 4 12.1481 4.22836C12.8831 4.53284 13.4672 5.11687 13.7716 5.85195C14 6.40326 14 7.10218 14 8.5C14 9.89782 14 10.5967 13.7716 11.1481C13.4672 11.8831 12.8831 12.4672 12.1481 12.7716C11.7135 12.9516 11.1872 12.9898 10.2992 12.9978C10.1339 12.9993 10 13.1333 10 13.2986V13.7C10 13.8657 10.1343 14 10.3 14H10.5C10.7761 14 11 14.2239 11 14.5V14.8C11 14.9105 10.9105 15 10.8 15H5.2C5.08954 15 5 14.9105 5 14.8V14.5C5 14.2239 5.22386 14 5.5 14H5.7C5.86569 14 6 13.8657 6 13.7V13.2986C6 13.1333 5.86611 12.9993 5.70078 12.9978C4.81279 12.9898 4.28652 12.9516 3.85195 12.7716C3.11687 12.4672 2.53284 11.8831 2.22836 11.1481C2 10.5967 2 9.89782 2 8.5C2 7.10218 2 6.40326 2.22836 5.85195C2.53284 5.11687 3.11687 4.53284 3.85195 4.22836C4.40326 4 5.10218 4 6.5 4H7C7.27614 4 7.5 3.77614 7.5 3.5V2.86622C7.2011 2.69331 7 2.37014 7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2ZM5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8ZM12 7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7ZM6.4 9C6.17909 9 6 9.17909 6 9.4V10.1C6 10.3209 6.17909 10.5 6.4 10.5H9.6C9.82091 10.5 10 10.3209 10 10.1V9.4C10 9.17909 9.82091 9 9.6 9H6.4Z"
		/>
	</svg>
))
